import { render } from "./ReservationCook.vue?vue&type=template&id=632cbc3e&scoped=true"
import script from "./ReservationCook.vue?vue&type=script&lang=js"
export * from "./ReservationCook.vue?vue&type=script&lang=js"

import "./ReservationCook.vue?vue&type=style&index=0&id=632cbc3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632cbc3e"]])

export default __exports__